var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.448186 1.06061C0.741079 0.767719 1.21595 0.767719 1.50885 1.06061L6.97852 6.53028L12.4482 1.06061C12.7411 0.767719 13.216 0.767719 13.5088 1.06061C13.8017 1.35351 13.8017 1.82838 13.5088 2.12127L8.03918 7.59094L13.5088 13.0606C13.8017 13.3535 13.8017 13.8284 13.5088 14.1213C13.216 14.4142 12.7411 14.4142 12.4482 14.1213L6.97852 8.6516L1.50885 14.1213C1.21595 14.4142 0.741079 14.4142 0.448186 14.1213C0.155292 13.8284 0.155292 13.3535 0.448186 13.0606L5.91786 7.59094L0.448186 2.12127C0.155292 1.82838 0.155292 1.35351 0.448186 1.06061Z",
    fill: "#A0A3A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.2d7a930ab604e464cb0b8cd0c2c2ecc0.svg";
export { ForwardRef as ReactComponent };